import React from "react";
import { QUESTION_GROUP_TYPE_CODE } from "./TestQuestionGroup";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { modifyMediaUrl } from "../helpers/modifyMediaUrl";

export const TestQuestionAnswer = ({ question, handleChangeAnswer, userQuestionAnswer }) => {
  const onRadioChange = (e, questionId) => {
    handleChangeAnswer({
      questionId,
      answerId: [e.value],
    });
  };

  const onInputTextChange = (e, questionId) => {
    handleChangeAnswer({
      questionId,
      answerText: e.target.value,
    });
  };

  return (
    <div>
      {question?.questionTypeCode === QUESTION_GROUP_TYPE_CODE.WRITING && (
        <InputTextarea className="w-full" value={userQuestionAnswer?.answerText} onChange={(e) => onInputTextChange(e, question?.id)} rows={2} />
      )}
      {question?.questionTypeCode !== QUESTION_GROUP_TYPE_CODE.WRITING && (
        <div className="pre-test-answer-wrapper">
          {question?.answers.map((answer, index) => (
            <div key={index} className="pre-test-answer-item">
              <label htmlFor={answer?.id} className="cursor-pointer select-none flex align-items-center">
                <RadioButton
                  inputId={answer?.id}
                  value={answer?.id}
                  onChange={(e) => onRadioChange(e, question?.id)}
                  checked={userQuestionAnswer?.answerId.includes(answer?.id)}
                ></RadioButton>
                {answer?.imageUrl ? (
                  <div className="object-cover overflow-hidden flex-1">
                    <img src={modifyMediaUrl(answer.imageUrl)} alt={index + 1} className="pl-075 w-full" />
                  </div>
                ) : (
                  <h6 className="keduall-typography heading-h6-normal-400 pl-075">{answer?.answer}</h6>
                )}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
